/**
 * 検索パターン
 */
import Vue from "vue";
import * as httpConst from "../../../../constants/httpConst";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/condition_patterns`;

const master_condition_pattern = {
  namespaced: true,
  state: () => {},
  getters: {},
  actions: {
    /**
     * 検索パターン取得
     * @param commit
     * @param classification { String } 検索種別
     * @return {Promise<unknown>}
     */
    index({ commit }, { classification }) {
      const params = {
        classification: classification,
      };
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then((data) => {
          resolve(data.content);
        });
      });
    },
    /**
     * 検索パターン取得
     * @param commit
     * @param id { Number } 検索パターンID
     * @return {Promise<unknown>}
     */
    show({ commit }, { id }) {
      return new Promise((resolve) => {
        Vue.$http.get(`${API_PATH}/${id}`).then((data) => {
          resolve(data.content);
        });
      });
    },
    /**
     * 検索パターン登録
     */
    create({ commit }, { params }) {
      return new Promise((resolve) => {
        Vue.$http.post(API_PATH, params).then((data) => {
          let content = data.content;
          commit(
            "snackbar/showInfo",
            { message: "登録しました" },
            { root: true }
          );
          resolve(content);
        });
      });
    },
    /**
     * 検索パターン削除
     */
    destroy({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`;
      return new Promise((resolve) => {
        Vue.$http.delete(api_path).then((data) => {
          commit(
            "snackbar/showInfo",
            { message: "削除しました" },
            { root: true }
          );
          resolve(data.content);
        });
      });
    },
  },
  mutations: {},
};

export default master_condition_pattern;
